import { Flex } from '@chakra-ui/react'
import { ButtonCmp } from '../../../../../components/ButtonCmp'
import { ModalBase } from '../../../../../components/ModalBase'

interface props {
  isOpen: boolean
  onRequestClose: () => void
  historicos: string[]
}

export const ModalHistorico: React.FC<props> = ({ isOpen, onRequestClose, historicos }) => {
  return (
        <ModalBase
            isOpen={isOpen}
            onClose={onRequestClose}
            Titulo={'Outros momentos em que essa ação foi remanejada'}
            Width='34rem'
        >
            <Flex flexDir={'column'} gap={'.875rem'} px={'1rem'} pt={'.5rem'}>
                {historicos.map((e, i) => {
                  return <Flex bg={i === (historicos.length - 1) ? 'var(--AzulOpacoBg)' : 'var(--c4)'} border={i === (historicos.length - 1) ? '1px solid var(--Azul)' : '1px solid var(--c6)'} borderRadius={'.25rem'} py={'.5rem'} px={'1rem'}>
                        {i === (historicos.length - 1) ? `Ação criada dia ${e}` : `Ação remanejada dia ${e}`}
                    </Flex>
                })}
            </Flex>
            <Flex justifyContent={'center'} gap={'1rem'} p={'1rem'}>
                <ButtonCmp VarColor='c6' onClick={onRequestClose}>Voltar</ButtonCmp>
            </Flex>

        </ModalBase>
  )
}
